/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 * Application Constants
 */
var resources = {
  csrfTokens: 'v1/csrf/tokens',
  userAccount: 'v1/ua/user_account',
  userAccountLogin: 'v1/ua/user_account_login',
  ssoVerifier: 'v1/ua/sso_verifier',
  systemConfigurations: 'v1/ua/system_configurations',
  generatedUserAccount: 'v1/ua/generated_user_accounts',
  profile: 'v1/ua/profile',
  messages: 'v1/ua/messages',
  applicationVerifications: 'v1/ua/application_verifications'
};
export default resources;